
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/--roboneo/[...path]",
      function () {
        return require("private-next-pages/--roboneo/[...path].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/--roboneo/[...path]"])
      });
    }
  